import { render, staticRenderFns } from "./VeJwCjClassInfo.vue?vue&type=template&id=01873592"
import script from "./VeJwCjClassInfo.vue?vue&type=script&lang=js"
export * from "./VeJwCjClassInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports